export const PieData = [
    {
      "id": "go",
      "label": "go",
      "value": 489,
      "color": "hsl(265, 70%, 50%)"
    },
    {
      "id": "hack",
      "label": "hack",
      "value": 179,
      "color": "hsl(357, 70%, 50%)"
    },
    {
      "id": "java",
      "label": "java",
      "value": 241,
      "color": "hsl(67, 70%, 50%)"
    },
    {
      "id": "elixir",
      "label": "elixir",
      "value": 581,
      "color": "hsl(304, 70%, 50%)"
    },
    {
      "id": "lisp",
      "label": "lisp",
      "value": 121,
      "color": "hsl(72, 70%, 50%)"
    }
  ]


 export const Defaultuser = {
  

    
    expenses:{

      categories:[
      //   {
      //     name:'food',
      //     budget: 3000,
    
      //     exp: [
      //       { 
      //       date: '16/1/2023',
      //        value: -100
      //       },
            
      //       { 
      //       date: '8/8/2023',
      //        value: -300
      //       },
            
      //       { 
      //       date: '18/9/2023',
      //        value: -123
      //       },
            
      //       { 
      //       date: '1/11/2023',
      //        value: -145
      //       },
            
      //       { 
      //       date: '28/8/2023',
      //        value: -24
      //       },
      //     ], 
      // },
      
      // {
      //   name:'entertaiment',
      //     budget: 3000,
      //     exp: [
      //       { 
      //       date: '20/7/2023',
      //         value: -10
      //        },
      //       { 
      //       date: '9/3/2023',
      //         value: -30
      //        },
      //       { 
      //       date: '16/3/2023',
      //         value: -23
      //        },
      //       { 
      //       date: '12/8/2023',
      //         value: -14
      //        },
      //       { 
      //       date: '18/5/2023',
      //         value: -24
      //        },
      //     ],     
      //   },
    
        
      // {
      //   name:'utility',
      //   budget: 3000,
      //   exp: [
      //     {
      //       date: '2/8/2023',
    
      //       value: -14
      //      },
      //     {
      //       date: '7/7/2023',
    
      //       value: -21
      //      },
      //     {
      //       date: '10/10/2023',
    
      //       value: -28
      //      },
      //     {
      //       date: '18/4/2023',
    
      //       value: -15
      //      },
      //     {
      //       date: '18/5/2023',
    
      //       value: -17
      //      },
      //   ],              
      // },
      // {
      //   name:'transport',
      //   budget: 3000,
      //   exp:[
      //     { 
      //       date: '18/3/2023',
      //       value: -101
      //      },
      //     { 
      //       date: '18/8/2023',
      //       value: -32
      //      },
      //     { 
      //       date: '18/7/2023',
      //       value: -213
      //      },
      //     { 
      //       date: '18/1/2023',
      //       value: -140
      //      },
      //     { 
      //       date: '2/8/2023',
      //       value: -247
      //      },
      //   ],              
      // },
    ]
    
},



    savings:{
        goals:[
            // {
            //     title:'phone',
            //     target: 200,
            //     current: [30, 40,10]
            // },
            // {
            //     title:'Laptop',
            //     target: 2100,
            //     current: [310, 140,10]
            // },
            // {
            //     title:'Rent',
            //     target: 2000,
            //     current: [300, 120,310]
            // }
        ]
    },
    income:[
      // {
      //   title: 'side gig',
      //   amount: 200
      // }
    ],
  
  }




  